<script>
import BoardEditorBreadcrumbs from '@/modules/board/components/BoardEditorBreadcrumbs';
import CompositionEditorBreadcrumbs from '@/modules/composition/components/CompositionEditorBreadcrumbs';
import DayPartingEditorBreadcrumbs from '@/modules/board/dayparting/components/DaypartingEditorBreadcrumbs';

const BOARD_TYPE = 'board';
const COMPOSITION_TYPE = 'composition';
const DAYPARTING_TYPE = 'dayparting';

export default {
  functional: true,
  props: {
    type: String,
    id: Number,
    compositionRelativeVersionId: Number,
    blockId: Number,
  },
  render(createElement, context) {
    const {
      type, id, compositionRelativeVersionId, blockId,
    } = context.props;
    switch (type) {
      case BOARD_TYPE:
        return createElement(BoardEditorBreadcrumbs, { props: { id, compositionRelativeVersionId } });
      case COMPOSITION_TYPE:
        return createElement(CompositionEditorBreadcrumbs, { props: { id, compositionRelativeVersionId } });
      case DAYPARTING_TYPE:
        return createElement(DayPartingEditorBreadcrumbs, { props: { refBoardId: id, blockId } });
      default:
        return null;
    }
  },
};
</script>
